import { render, staticRenderFns } from "./RateSheetVersionSelector.vue?vue&type=template&id=21728f6a&"
import script from "./RateSheetVersionSelector.vue?vue&type=script&lang=js&"
export * from "./RateSheetVersionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports